export enum MembersAndTeamsRoutesNamesEnum {
  MembersAndTeams = 'MembersAndTeams',
  Members = 'Members',
  Teams = 'Teams'
}
